export const PASSWORD_MIN = 6;
export const USERNAME_OR_PASSWORD_MIN = 6;
export const PASSWORD_MAX = 128;
export const NAME_MAX = 32;
export const PHONE_DIGIT_MAX = 15;
export const PHONE_DIGIT_MIN = 7;
export const DEFAULT_PHONE_LENGTH = 10;
// add room for space, two dashes, and a plus
export const PHONE_CHARACTER_MAX = PHONE_DIGIT_MAX + 4;
export const BLURB_CART = 'blurb_cart';
export const MAIN_REDIRECT = '/user/dashboard';
export const TEMP_REDIRECT = '/v2/auth/login-success';
export const TEMP_OIDC_REDIRECT = '/v1/auth/callback/oidc';
export const LARGE_ORDER_THRESHOLD = 99;
export const ITEMS_PER_PAGE = 10;
// number of days a project is retained after creation
export const DAYS_PROJECT_RETAINED = 14;
export const DAYS_UNTIL_PROJECT_STALE = 1;
